<div class="search-dialog">
  <div class="dialog-header">
    <div class="dialog-header-text">
      <h3 class="dialog-title"><nz-icon nzType="search"></nz-icon> Pesquisar</h3>
      <span class="dialog-subtitle">{{entityDesc}}</span>
    </div>
    <button nz-button nzType="text" nzShape="circle" id="close-icon" (click)="closeDialog(null)" aria-label="Fechar">
      <nz-icon nzType="close"></nz-icon>
    </button>
  </div>

  <div class="search-bar">
    <nz-select class="scope-select" [(ngModel)]="selectedColumn" (ngModelChange)="onScopeChange($event)" nzShowSearch nzAllowClear nzPlaceHolder="Todos os campos" nz-tooltip="Limitar a pesquisa a um campo específico">
      <nz-option *ngFor="let col of field" [nzValue]="col.value" [nzLabel]="col.viewValue"></nz-option>
    </nz-select>
    <nz-input-group [nzPrefix]="searchIconTpl" [nzSuffix]="clearTpl" class="search-input">
      <input nz-input #searchInput [type]="inputType" placeholder="Digite para pesquisar..." [(ngModel)]="searchText" (ngModelChange)="onSearchChange($event)">
    </nz-input-group>
    <ng-template #searchIconTpl><nz-icon nzType="search" class="search-icon"></nz-icon></ng-template>
    <ng-template #clearTpl>
      <nz-icon *ngIf="searchText" nzType="close-circle" class="clear-icon" (click)="searchText='';onSearchChange('')"></nz-icon>
    </ng-template>
  </div>

  <div class="table-container">
    <nz-table #table
      [nzData]="$any(rows)"
      [nzLoading]="loading"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      nzSize="small"
      [nzScroll]="{ y: 'calc(70vh - 200px)' }">
      <thead>
        <tr>
          <th *ngFor="let col of tableColumns" [nzWidth]="col.width + 'px'">{{col.name}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of table.data"
            class="result-row"
            [class.selected-row]="row === selectedRow"
            (click)="selectRow(row)"
            (dblclick)="confirm(row)">
          <td *ngFor="let col of tableColumns">
            <ng-container *ngIf="col.isDate">{{ row[col.prop] | date:'dd/MM/yyyy' }}</ng-container>
            <ng-container *ngIf="!col.isDate">{{ row[col.prop] }}</ng-container>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <div class="dialog-footer">
    <span class="rows-info">{{rows.length}} registro(s) — duplo clique seleciona direto</span>
    <div class="flex-spacer"></div>
    <button nz-button nzSize="small" (click)="closeDialog(null)">Cancelar</button>
    <button nz-button nzSize="small" nzType="primary" id="btn1-button" [disabled]="selectedRow == null" (click)="confirm()">Selecionar</button>
  </div>
</div>
